import {
  UsersPaged,
  UserItem,
} from "@/hooks/services/workchestra/handler/user-api";
import { ShopList, ShopItem } from "@/hooks/services/pps/handlers/shop-api";
import { MachineList } from "@/hooks/services/pps/handlers/machines-api";
import type { MachineGroupedItem } from "@/hooks/services/pps/types/machines.type";
import type { MultipleComboboxApiConfig } from "@/components/forms/form-multiple-combobox-async";

export const userSearchApiConfig: MultipleComboboxApiConfig = {
  apiFunction: UsersPaged,
  searchParams: (searchText: string) => ({
    currentPage: 1,
    itemsPerPage: 20,
    searchText: searchText,
  }),
  dataPath: "items",
  mapToItem: (user: UserItem) => ({
    id: user.id,
    label: user.userName,
    value: user.id,
    subtitle: `${user.fullName}`,
    raw: user,
  }),
};

export const shopSearchApiConfig: MultipleComboboxApiConfig = {
  apiFunction: ShopList,
  searchParams: (searchText: string) => ({
    search: searchText,
  }),
  dataPath: "data",
  mapToItem: (shop: ShopItem) => ({
    id: shop.id,
    label: shop.shopName,
    value: shop.id,
    subtitle: "",
    raw: shop,
  }),
};

export const machineMultipleApiConfig = (
  workspaceId?: number,
  shopId?: number,
): MultipleComboboxApiConfig => ({
  apiFunction: MachineList,
  searchParams: (searchText: string) => {
    const params: any = {
      search: searchText,
      page: 1,
      pageSize: 50,
    };
    if (workspaceId) params.workspaceId = workspaceId;
    if (shopId && shopId !== 0) params.shopId = shopId;
    return params;
  },
  dataPath: "data",
  mapToItem: (machine: MachineGroupedItem) => ({
    id: machine.id,
    label: `${machine.machineIdFormatted} - ${machine.name}`,
    value: machine.id,
    subtitle: machine.shop?.shopName || "",
    raw: machine,
  }),
});
